export const buttonPrimaryHover = 'var(--plasma-colors-button-primary-hover)';
export const buttonPrimaryActive = 'var(--plasma-colors-button-primary-active)';

export const buttonSecondaryHover = 'var(--plasma-colors-button-secondary-hover)';
export const buttonSecondaryActive = 'var(--plasma-colors-button-secondary-active)';

export const buttonSuccessHover = 'var(--plasma-colors-button-success-hover)';
export const buttonSuccessActive = 'var(--plasma-colors-button-success-active)';

export const buttonWarningHover = 'var(--plasma-colors-button-warning-hover)';
export const buttonWarningActive = 'var(--plasma-colors-button-warning-active)';

export const buttonCriticalHover = 'var(--plasma-colors-button-critical-hover)';
export const buttonCriticalActive = 'var(--plasma-colors-button-critical-active)';

export const buttonCheckedHover = 'var(--plasma-colors-button-checked-hover)';
export const buttonCheckedHoverColor = 'var(--plasma-colors-button-checked-hover-color)';
export const buttonCheckedActive = 'var(--plasma-colors-button-checked-active)';
export const buttonCheckedActiveColor = 'var(--plasma-colors-button-checked-active-color)';

export const fieldColor = 'var(--plasma-field-color)';
export const fieldLabelColor = 'var(--plasma-field-label-color)';

export const inputBackground = 'var(--plasma-input-background-color)';
export const inputBackgroundHover = 'var(--plasma-input-hover-background-color)';
export const inputBackgroundFocus = 'var(--plasma-input-focus-background-color)';
export const inputColor = 'var(--plasma-input-color)';
export const inputCaretColor = 'var(--plasma-input-caret-color)';
export const inputPlaceholderColor = 'var(--plasma-input-placeholder-color)';
export const inputFocusPlaceholderColor = 'var(--plasma-input-focus-placeholder-color)';
export const inputBorder = 'var(--plasma-colors-input-border)';
export const inputBorderHover = 'var(--plasma-colors-input-border-hover)';
export const inputBorderFocus = 'var(--plasma-colors-input-border-focus)';
export const inputSuccessBackground = 'var(--plasma-input-success-background)';
export const inputSuccessColor = 'var(--plasma-input-success-color)';
export const inputSuccessCaretColor = 'var(--plasma-input-success-caret-color)';
export const inputSuccessBorderColor = 'var(--plasma-input-success-border-color)';
export const inputWarningBackground = 'var(--plasma-input-warning-background)';
export const inputWarningColor = 'var(--plasma-input-warning-color)';
export const inputWarningCaretColor = 'var(--plasma-input-warning-caret-color)';
export const inputWarningBorderColor = 'var(--plasma-input-warning-border-color)';
export const inputErrorBackground = 'var(--plasma-input-error-background)';
export const inputErrorColor = 'var(--plasma-input-error-color)';
export const inputErrorCaretColor = 'var(--plasma-input-error-caret-color)';
export const inputErrorBorderColor = 'var(--plasma-input-error-border-color)';
export const inputLabelColor = 'var(--plasma-input-label-color)';

export const link = 'var(--plasma-colors-link)';
export const linkHover = 'var(--plasma-colors-link-hover)';
export const linkActive = 'var(--plasma-colors-link-active)';
export const linkVisited = 'var(--plasma-colors-link-visited)';
export const linkVisitedHover = 'var(--plasma-colors-link-visited-hover)';
export const linkVisitedActive = 'var(--plasma-colors-link-visited-active)';
